/**
 * Экран не увеличивается щипком и двойным касанием — ни на сайте, ни в
 * Telegram, ни во Flutter-приложении: это приложение, а не страница, и
 * увеличенная вёрстка застревает — в мини-аппе и WebView вернуть масштаб нечем.
 * `maximum-scale=1` заодно не даёт iOS приближать поле ввода при фокусе.
 *
 * Android и WebView слушают viewport; Safari на iOS его `user-scalable`
 * пропускает, и щипок гасим событием `gesturestart`. Карта адреса щипок ловит
 * сама, и её масштаб это не трогает.
 */
export function lockZoom(): void {
  const viewport = document.querySelector<HTMLMetaElement>('meta[name="viewport"]')
  if (viewport && !viewport.content.includes('user-scalable')) {
    viewport.content += ', maximum-scale=1, user-scalable=no'
  }
  document.addEventListener('gesturestart', (event) => {
    event.preventDefault()
  })
}
